let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jnAJn"), load("5uN9h"), load("4uUio")]).then(() => parcelRequire('ayZRr'));